<div class="container">
  <h1 class="header">{{ "ui.new-message" | translate }}</h1>

  <h2 class="header">{{ "ui.table.receiver" | translate }}</h2>

  <div class="selection-container">
    <div class="spacer"></div>
    <mat-form-field>
      <mat-label>{{ "ui.new-vehicle" | translate }}</mat-label>
      <mat-select [formControl]="SelectedCrafts" multiple
                  (selectionChange)="onCraftSelectionChange()"
                  (openedChange)="onCraftPanelToggle($event)">
        <mat-select-trigger>
          <ng-container *ngIf="getSelectedCraftCount() === 1 && getFirstSelectedCraft() as craft">
            {{ craft.craftNr }}
          </ng-container>
          <ng-container *ngIf="getSelectedCraftCount() > 1">
            {{ getSelectedCraftCount() }} {{ "ui.new.selected" | translate }}
          </ng-container>
        </mat-select-trigger>
        <mat-option disabled class="search-option">
          <input [(ngModel)]="searchCraft"
                 (input)="filterCrafts()"
                 (keydown)="$event.key === 'Escape' || $event.stopPropagation()"
                 [placeholder]="'ui.new.search-placeholder' | translate"
                 class="select-search-input">
        </mat-option>
        <mat-option [value]="ALL_CRAFTS_VALUE" class="select-all-option">
          <mat-checkbox
            [checked]="isAllCraftsSelected()"
            [indeterminate]="isCraftsIndeterminate()"
            style="pointer-events: none;">
            {{ "ui.new.select-all-vehicles" | translate }}
          </mat-checkbox>
        </mat-option>
        <mat-option *ngFor="let craft of filteredCrafts" [value]="craft">
          {{ craft.craftNr }}
        </mat-option>
        <mat-option *ngFor="let craft of hiddenSelectedCrafts" [value]="craft" class="hidden-option">
        </mat-option>
      </mat-select>
    </mat-form-field>
    
    <div class="spacer"></div>

    <mat-form-field>
      <mat-label>{{ "ui.new-employees" | translate }}</mat-label>
      <mat-select [formControl]="SelectedDrivers" multiple
                  (selectionChange)="onDriverSelectionChange()"
                  (openedChange)="onDriverPanelToggle($event)">
        <mat-select-trigger>
          <ng-container *ngIf="getSelectedDriverCount() === 1 && getFirstSelectedDriver() as driver">
            {{ driver.fullName }}
          </ng-container>
          <ng-container *ngIf="getSelectedDriverCount() > 1">
            {{ getSelectedDriverCount() }} {{ "ui.new.selected" | translate }}
          </ng-container>
        </mat-select-trigger>
        <mat-option disabled class="search-option">
          <input [(ngModel)]="searchDriver"
                 (input)="filterDrivers()"
                 (keydown)="$event.key === 'Escape' || $event.stopPropagation()"
                 [placeholder]="'ui.new.search-placeholder' | translate"
                 class="select-search-input">
        </mat-option>
        <mat-option [value]="ALL_DRIVERS_VALUE" class="select-all-option">
          <mat-checkbox
            [checked]="isAllDriversSelected()"
            [indeterminate]="isDriversIndeterminate()"
            style="pointer-events: none;">
            {{ "ui.new.select-all-drivers" | translate }}
          </mat-checkbox>
        </mat-option>
        <mat-option *ngFor="let driver of filteredDrivers" [value]="driver">
          {{ driver.fullName }}
        </mat-option>
        <mat-option *ngFor="let driver of hiddenSelectedDrivers" [value]="driver" class="hidden-option">
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="spacer"></div>
  </div>

  <form [formGroup]="regForm">
    <mat-form-field class="full-width">
      <mat-label>{{ "ui.table.message" | translate }}</mat-label>
      <input matInput #message type="text" id="messageText" formControlName="messageText" />
    </mat-form-field>
  </form>

  <div class="right">
    <mat-spinner *ngIf="sending" [diameter]="20"></mat-spinner>
    <button mat-icon-button (click)="sendMessage()" matTooltip="Senden" [disabled]="sending">
      <mat-icon *ngIf="!sending">done</mat-icon>
    </button>

    <button color="warn" routerLink="/messages" mat-icon-button matTooltip="Abbrechen">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>